module.exports = __webpack_public_path__ + "static/img/A72.2737a3ca.jpg";